export function RentalScene({
  transfer = false,
  compact = false,
}: {
  transfer?: boolean;
  compact?: boolean;
}) {
  const start = transfer ? 8 : 6,
    rate = transfer ? 4 : 3,
    total = transfer ? 20 : 18;
  return (
    <section
      className={`rental-scene ${compact ? 'compact' : ''}`}
      aria-label={`Fictional bike rental: ${start} dollars starting charge, ${rate} dollars per hour, ${total} dollars total`}
    >
      <div className="rental-caption">
        <span className="eyebrow">
          {transfer
            ? 'A different rental. Your model.'
            : 'The idea, out in the world.'}
        </span>
        <h2>
          A little algebra.
          <br />
          <em>A longer ride.</em>
        </h2>
      </div>
      <svg
        viewBox="0 0 740 380"
        className="bike-illustration"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="sky" x2="0" y2="1">
            <stop stopColor="#e9efdf" />
            <stop offset="1" stopColor="#d1dfcf" />
          </linearGradient>
          <linearGradient id="floor" x2="0" y2="1">
            <stop stopColor="#d3dbc5" />
            <stop offset="1" stopColor="#b0c3a9" />
          </linearGradient>
          <filter id="shadow">
            <feGaussianBlur stdDeviation="8" />
          </filter>
        </defs>
        <path d="M0 0h740v380H0Z" fill="url(#sky)" />
        <circle cx="594" cy="70" r="55" fill="#fff7cc" opacity=".75" />
        <path d="M0 211q100-67 218-8t226-22 296 20v179H0Z" fill="#bdcfb5" />
        <path d="M0 270q210-100 425-6t315-16v132H0Z" fill="url(#floor)" />
        <path d="M0 339 740 310" stroke="#e8edde" strokeWidth="38" />
        <ellipse
          cx="391"
          cy="314"
          rx="221"
          ry="16"
          fill="#3c6645"
          opacity=".15"
          filter="url(#shadow)"
        />
        <g stroke="#466851" strokeWidth="3">
          <path d="M99 295v-115m0 25-31-20m31 58 31-23m-31 48-29-13" />
          <ellipse
            cx="82"
            cy="183"
            rx="19"
            ry="8"
            transform="rotate(30 82 183)"
            fill="#72966c"
            stroke="none"
          />
          <ellipse
            cx="121"
            cy="219"
            rx="20"
            ry="9"
            transform="rotate(-32 121 219)"
            fill="#678e65"
            stroke="none"
          />
          <ellipse
            cx="79"
            cy="255"
            rx="18"
            ry="8"
            fill="#65845c"
            stroke="none"
          />
        </g>
        <path d="m68 286 13 53h39l11-53Z" fill="#b67c52" />
        <path d="M64 284h70v12H64Z" fill="#c79366" />
        <g fill="#eff4e4" stroke="#294d43" strokeWidth="8">
          <circle cx="263" cy="261" r="65" />
          <circle cx="530" cy="261" r="65" />
        </g>
        <g stroke="#a4b5a2" strokeWidth="1.4">
          {Array.from({ length: 12 }, (_, i) => {
            const a = (i * Math.PI) / 6;
            return (
              <g key={i}>
                <path d={`M263 261l${Math.cos(a) * 60} ${Math.sin(a) * 60}`} />
                <path d={`M530 261l${Math.cos(a) * 60} ${Math.sin(a) * 60}`} />
              </g>
            );
          })}
        </g>
        <g
          fill="none"
          stroke="#cf9d5a"
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m263 261 73-110 69 110Zm142 0 80-115H336M530 261l-55-158" />
          <path d="m336 151-10-28" />
        </g>
        <path
          d="M302 122h46"
          stroke="#35554a"
          strokeWidth="11"
          strokeLinecap="round"
        />
        <path
          d="m475 103-8-22h39"
          fill="none"
          stroke="#45675c"
          strokeWidth="7"
          strokeLinecap="round"
        />
        <path
          d="m489 108 78-3-13 51h-53Z"
          fill="#d9c198"
          stroke="#a6885d"
          strokeWidth="3"
        />
        <path
          d="M508 112v34m18-36v38m18-38v34m-46-21h62m-58 13h55"
          stroke="#b39870"
          strokeWidth="2"
        />
        <circle cx="405" cy="261" r="13" fill="#375448" />
        <path
          d="m405 261 17 23h15"
          fill="none"
          stroke="#36544b"
          strokeWidth="5"
          strokeLinecap="round"
        />
        <g fill="#e9f1df">
          <path d="m602 286 3-27 5 27Zm18 2 5-21 4 20Z" />
          <path d="m182 330 4-19 4 19Z" />
        </g>
      </svg>
      <div className="price-strip">
        <div>
          <span className="price">${start}</span>
          <span>one-time charge</span>
        </div>
        <div>
          <span className="price">
            ${rate}
            <small> / hour</small>
          </span>
          <span>hourly rate</span>
        </div>
        <div>
          <span className="price">${total}</span>
          <span>receipt total</span>
        </div>
      </div>
    </section>
  );
}
